import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=a9da0a70&scoped=true"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=a9da0a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9da0a70",
  null
  
)

export default component.exports